import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import YeloLogo from 'app/components/Icons/YeloLogo';
import LargeSearchIcon from 'app/components/Icons/LargeSearchIcon';
import { container, header, line, mainText, secondaryText } from './NotFoundPage.sx';
import useNotFoundPage from './useNotFoundPage';
import {NavLink} from "react-router-dom";

const NotFoundPage = () => {
  const { homePagaHandler } = useNotFoundPage();

  return (
    <Box sx={container}>
      <Box sx={line}></Box>
      <Box sx={header}>
          <NavLink to={`/az/home-page`}>
                <YeloLogo />
          </NavLink>
      </Box>
      <Divider sx={{ width: '100%' }} />
      <LargeSearchIcon sx={{ mt: '49px' }} />
      <Typography sx={mainText}>Səhifə tapılmadı!</Typography>
      <Typography sx={secondaryText}>
        Zəhmət olmasa, ana səhifəmizi ziyarət edin və ya məlumat mərkəzinə yazın.
      </Typography>
      <Button onClick={homePagaHandler} sx={{ mt: '24px' }}>
        Ana səhifə
      </Button>
    </Box>
  );
};

export default NotFoundPage;
